module.exports = __webpack_public_path__ + "static/media/GatewayUpgrade.616a2393.svg";